import React, { useState } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "15px",
    fontWeight: "bold",
};

function AddFloor() {
    const [floor, setFloor] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            floor: floor,
        };
        try {
            const res = await HomeService.addFloor(data);
            if (res?.status) {
                toast.success("Floor added successfully!");
                clearAddForm();
                navigate("/manage-floor");
            }
        } catch (error) {
            toast.error("Failed to add floor.");
            console.error("Error adding floor:", error);
        }
    };

    const clearAddForm = () => {
        setFloor("");
    };

    return (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
            <div className="container-fluid">

                <div className="mt-5">
                    <div style={headLineStyle} className="page-headline">
                        Add Floor
                    </div>
                    <hr />

                    <section className="chartBox_area">

                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6 mt-3">
                                    <label htmlFor="floor">
                                        Floor<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="floor"
                                        className="form-control"
                                        value={floor}
                                        onChange={(e) => setFloor(e.target.value)}
                                        placeholder="Enter Floor"
                                        required
                                    />
                                </div>
                            </div>
                            <button
                                type="submit"
                                className="btn btn-primary mt-3"
                            >
                                Add Floor
                            </button>
                        </form>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default AddFloor;
